<template>
  <div>
    <div
      class="d-flex justify-between"
    >
      <div class="d-flex">
        <h4 class="text-black mt-50">
          <strong>
            Riwayat Perjalanan
          </strong>
        </h4>
        <img
          :src="shipingImage"
          class="w-16 mx-1"
        >
      </div>
      <img
        v-if="$route.name === 'search-order'"
        src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/close-circle.svg"
        type="button"
        @click="$bvModal.hide('tracking-resi')"
      >
    </div>
    <b-row class="my-8 overflow-auto">
      <div
        v-if="itemAwb.length > 0"
      >
        <b-row
          v-for="(item, index) in itemAwb"
          :key="index"
          class="my-1"
        >
          <b-col
            cols="3"
            class="pl-[5px]"
            style="text-align: -webkit-center"
          >
            <img
              :src="iconAwb(item)"
              alt="icon-shipping"
            >
            <div
              v-if="index !== itemAwb.length - 1"
              class="border-dashed border-2 border-[#FBA63C] d-inline-block h-100"
            />
          </b-col>
          <b-col
            cols="9"
            class="d-inline-block"
          >
            <div>{{ FULL_DATE_TIME(item.date) }}</div>
            <div
              v-if="item.status === 'Problem'"
              class="align-self-center"
            >
              <div class="text-danger font-semibold">
                Kendala Pengiriman
              </div>
              <div
                class="p-1 border-2 bordered-[#E2E2E2]"
              >
                <div class="font-bold my-[5px]">
                  {{ item.desc }}
                </div>
                <div class="d-flex">
                  <img
                    src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/truck-remove.svg"
                    alt="truck-remove"
                  >
                  <div class="mx-1">
                    <span>
                      Keterangan dari ekspedisi : <span v-if="item.notes !== null">{{ item.notes }}</span> <span v-else>-</span>
                    </span><br>
                    <a
                      v-if="item.proof_image !== null && item.proof_image !== ''"
                      class="text-danger"
                      :href="item.proof_image"
                      target="_blank"
                    >[Lihat Bukti]</a>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              class=""
            >
              <div class="font-bold">
                {{ item.desc }}
              </div>
              <div v-if="item.send_wa === 1">
                <div
                  class="d-flex relative p-1 mx-1 border-2 bordered-[#E2E2E2] rounded w-50"
                >
                  <img
                    src="https://storage.googleapis.com/komerce/assets/svg/WA-Premium.svg"
                    alt="wa-premium"
                  >
                  <span
                    v-if="item.type === 'sending'"
                    class="my-auto ml-1"
                  >Pemberitahuan pemberangkatan telah terkirim ke WA Pelanggan</span>
                  <span
                    v-if="item.type === 'arrived'"
                    class="my-auto ml-1"
                  >Info paket COD hampir sampai telah terkirim ke WA Pelanggan</span>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
      <b-col v-if="itemAwb.length === 0">
        <div
          v-if="isLoading===false"
          class="d-block mt-5 mb-5 align-content-center text-center"
        >
          Data riwayat perjalan tidak ditemukan. <b>Bisa jadi</b> sudah request pickup/dijemput kurir saat pickup namun <b>belum discan</b> QR code untuk memulai perjalanan di kantor cabang. Harap menunggu
        </div>
        <div
          v-if="isLoading===true"
          class="d-block mt-5 mb-5 align-content-center text-center"
        >
          <div
            class="spinner-border text-primary"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { FULL_DATE_TIME } from '@/libs/filterDate'

export default {
  props: {
    awb: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      listAwb: '',
      itemAwb: [],
      shipingImage: '',
      FULL_DATE_TIME,
    }
  },
  async mounted() {
    await this.getHistoryPackage()
  },
  methods: {
    async getHistoryPackage() {
      const body = {
        awb: this.awb,
      }
      await this.$http_komship.post('/v1/global/check-awb', body).then(res => {
        const { data } = res.data
        this.itemAwb = data.history
        this.shipingImage = data.shipping_icon
        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
      })
    },
    iconAwb(items) {
      let result = ''
      if (items.status === 'Pickup') {
        result = 'https://storage.googleapis.com/komerce/assets/icons/resi-pickup.svg'
      } else if (items.status === 'Process') {
        result = 'https://storage.googleapis.com/komerce/assets/icons/resi-kirim.svg'
      } else if (items.status === 'Problem') {
        result = 'https://storage.googleapis.com/komerce/assets/icons/resi-problem.svg'
      } else if (items.status === 'Delivered') {
        result = 'https://storage.googleapis.com/komerce/assets/icons/resi-terima.svg'
      } else if (items.status === 'Retur') {
        result = 'https://storage.googleapis.com/komerce/assets/icons/resi-retur.svg'
      } else if (items.status === 'Delivery') {
        result = 'https://storage.googleapis.com/komerce/assets/icons/resi-delivery.svg'
      }
      return result
    },
  },
}
</script>
<style lang src="./HistoryTiket.scss" />
